// extracted by mini-css-extract-plugin
export default {"container":"Trailer-module--container--XtMFG","content":"Trailer-module--content--MEuS4","name":"Trailer-module--name--3GdCk","btn":"Trailer-module--btn--LgU4f"};